import { Component } from '@angular/core';
import { AppSettingsService } from '../../../../shared/services/appsettings.service';

@Component({
  selector: 'contest-introduction',
  templateUrl: './contest-introduction.component.html',
  styleUrls: ['./contest-introduction.component.css']
})

export class ContestIntroduction {
  lastCompletedContestYear: number;

  ngOnInit() {
    this.lastCompletedContestYear = AppSettingsService.settings.lastCompletedContestYear;
  }
}
